module.exports = __webpack_public_path__ + "img/newInt-eyeicon.0134b214.svg";